export default __webpack_public_path__ + "static/media/afiliados.7c324825.png";